import styled, { keyframes } from 'styled-components'

const animation = keyframes`
from {
    transform: rotate(360deg);
}
to {
    transform: rotate(0deg);
}
`
export const LoadingContainer = styled.div`
  position: absolute;
  top: 27.18%;
  width: 75%;
  height: auto;
  margin: 0px;

  display: flex;
  flex-direction: column;
  align-items: center;
`

export const IconWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`
export const CircleIcon = styled.img`
  position: relative;
  animation: ${animation} 1.5s linear infinite;
`
export const CenterIcon = styled.img`
  position: absolute;
  top: 53px;
`
export const LoadingPageContent = styled.div`
  position: relative;
  text-align: center;
  line-height: 1.5;
  margin: 0;
  text-size-adjust: 100%;
  max-width: 350px;
`
export const PageTitle = styled.div`
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  padding-bottom: 15px;
`
export const PageSubtitle = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
`
